import React, { useContext, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { classNames } from 'primereact/utils';

import { handleRedirection, openLinkInBlank } from 'utils/utils';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { UserDetailsContext } from 'context/userDetailsContext';
import { Card } from 'primereact/card';
import { getTenantIdFromLS, getTenantSkFromLS, handleSettingSkAndPkToLocalStorage } from 'utils/localStorageUtils';
import { generateFullName } from 'utils/generateFullNameUtils';
import constants from 'constants/index';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import { Checkbox } from 'primereact/checkbox';
import { updateCaseNote } from 'services/CaseNoteServices';
import { ReactComponent as IncomingIcon } from 'assets/svg/incoming_call_dashboard.svg';

import { updateMessageThread } from 'services/messageServices';

export default function NeedResolution(props) {
  const { caseNoteList, fetchCaseNotes, leadDetails, caseSecureMessages, loadCaseSecureMessages, fetchLeadDetails } = props;

  const { addToast } = useToast();
  const history = useHistory();
  const userDetails = useContext(UserDetailsContext);
  const [resolved, setResolved] = useState({});
  const emptyDataValue = '-';

  const handleRedirectionInLeadOverViewPage = (params) => {
    const { history, url, stateToPass, sk, pk } = params || {};
    handleSettingSkAndPkToLocalStorage(sk, pk);
    handleRedirection(history, url, stateToPass);
  };

  const updateCaseNoteDetails = (note, value) => {
    let data = JSON.parse(JSON.stringify(note));
    if (data.resolved_status !== value) {
      data.resolved_status = value;
    }
    updateCaseNote(data)
      .then((response) => {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.NOTE_UPDATED_CREATED);
        fetchCaseNotes();
      })
      .catch((error) => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.NOTE_UPDATED_FAILED);
      })
      .finally(() => {
        fetchLeadDetails();
      });
  };

  const updateSecureMessageDetails = (msg, value) => {
    const tenantId = getTenantIdFromLS();
    const tenant_sk = getTenantSkFromLS();
    let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
    let data = JSON.parse(JSON.stringify(msg));
    if (data.resolved_status !== value) {
      data = { ...msg, resolved_status: true };
    }
    updateMessageThread(tenantId, tenantSk, data, msg?.is_lead ? true : false)
      .then((response) => {
        addToast(
          false,
          toastConstant.toasterType.SUCCESS,
          toastConstant.api.SUCCESS,
          toastConstant.message.SECURE_MESSAGE_THREAD_UPDATED_SUCCESS
        );
        loadCaseSecureMessages({
          case_id: props?.caseDetails?.case_id,
          isLeadSpecific: props?.caseDetails?.is_lead ? props?.caseDetails?.is_lead : false,
          isFromCaseSpecificModule: props?.isFromCaseSpecificModule,
          isGlobalMessagesScreen: false,
          resolution_status: true,
        });
      })
      .catch((error) => {
        addToast(
          false,
          toastConstant.toasterType.ERROR,
          toastConstant.api.FAILED,
          toastConstant.message.SECURE_MESSAGE_THREAD_UPDATED_FAILED
        );
      })
      .finally(() => {
        fetchLeadDetails();
      });
  };

  return (
    <>
      <div className="caption-bold mb-2 mt-3">{`Needs Resolution (${
        // (caseNoteList?.filter((val) => val?.resolution_status && !val?.resolved_status)?.length || 0) +
        // (caseSecureMessages?.filter((val) => val?.resolution_status && !val?.resolved_status)?.length || 0)
        (leadDetails?.case_note_need_resolution?.filter((val) => val?.resolution_status && !val?.resolved_status)?.length || 0) +
        (leadDetails?.message_need_resolution?.filter((val) => val?.resolution_status && !val?.resolved_status)?.length || 0)
      })`}</div>

      <Card
        className="card-bg mb-3"
        style={{
          height:
            // (caseNoteList?.filter((dat) => dat.resolution_status && !dat.resolved_status).length || 0) +
            (leadDetails?.case_note_need_resolution?.filter((dat) => dat.resolution_status && !dat.resolved_status).length || 0) +
              // (caseSecureMessages?.filter((dat) => dat.resolution_status && !dat.resolved_status).length || 0) >
              (leadDetails?.message_need_resolution?.filter((dat) => dat.resolution_status && !dat.resolved_status).length || 0) >
            2
              ? '400px'
              : 'auto',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {!(
          // caseNoteList?.some((dat) => dat?.resolution_status && !dat?.resolved_status) ||
          (
            leadDetails?.case_note_need_resolution?.some((dat) => dat?.resolution_status && !dat?.resolved_status) ||
            // caseSecureMessages?.some((dat) => dat?.resolution_status && !dat?.resolved_status)
            leadDetails?.message_need_resolution?.some((dat) => dat?.resolution_status && !dat?.resolved_status)
          )
        ) && <div className="p-card-content F-size14 mb-0">N/A</div>}

        {leadDetails?.case_note_need_resolution
          // {caseNoteList
          ?.filter((dat) => dat?.resolution_status && !dat?.resolved_status)
          .map((note, index) => {
            const { sk, pk, case_id, created_by_firm_user_id, call_type, case_note_id } = note;

            return (
              <Card className="mb-3 card-bg" key={`note-${index}`}>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="d-flex align-items-center F-size14 text-medium p-lg-0 py-2 w-100">
                      {note?.note_type && (
                        <div className="icon-container icon-bg text-primary-dark mx-1">
                          {note?.call_type === 'incoming' ? (
                            <IncomingIcon width={15} height={15} className="text-primary-dark" />
                          ) : (
                            <i
                              className={`${
                                note?.note_type === 'case_note' ? 'icon-casedocument text-primary-dark' : 'icon-callBack text-primary-dark'
                              }`}
                            ></i>
                          )}
                        </div>
                      )}
                      {note?.title ? (
                        <Link
                          to={{
                            pathname:
                              case_id || leadDetails?.case_id
                                ? `/leads/${case_id || leadDetails?.case_id}/notes/${case_note_id}`
                                : '/leads',
                            state: { caseNoteData: note },
                          }}
                          title={note?.title}
                          onClick={(e) => {
                            const caseId = case_id || leadDetails?.case_id;
                            let url = caseId ? `/leads/${caseId}/notes/${case_note_id}` : '/leads';
                            let stateToPass = { caseNoteData: note };

                            if (!openLinkInBlank(url, stateToPass)) {
                              handleRedirectionInLeadOverViewPage({ history, url, stateToPass, sk, pk });
                            }
                          }}
                          className={`note text-truncate w-100 call-back redirection-link-no-text-transform ${
                            note?.title ? 'pointer' : ''
                          }`}
                        >
                          {note?.title}
                        </Link>
                      ) : (
                        emptyDataValue
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    {note?.note_type === 'case_note' ? (
                      <Link
                        className={`mx-2 ${classNames({
                          'redirection-link-no-text-transform': Boolean(generateFullName(note?.created_by_name)),
                        })}`}
                        to={{
                          pathname: created_by_firm_user_id
                            ? `/settings/team-management/${created_by_firm_user_id}`
                            : '/settings/team-management',
                          state: { caseNoteData: note },
                        }}
                        onClick={() => {
                          let url = created_by_firm_user_id
                            ? `/settings/team-management/${created_by_firm_user_id}`
                            : '/settings/team-management';

                          let stateToPass = { caseNoteData: note };
                          handleRedirectionInLeadOverViewPage({ history, url, stateToPass, sk, pk });
                        }}
                      >
                        {note?.created_by_firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                        {note?.created_by_name ? generateFullName(note?.created_by_name) : emptyDataValue}
                      </Link>
                    ) : (
                      <div className="mx-2">
                        Caller:{' '}
                        <Link
                          className={classNames({
                            'redirection-link-no-text-transform': Boolean(
                              note?.caller_name?.client_name || note?.person_called?.client_name
                            ),
                          })}
                          to={
                            call_type === 'incoming'
                              ? `/contacts/${note?.caller_name?.client_id || ''}`
                              : `/contacts/${note?.person_called?.client_id || ''}`
                          }
                          onClick={() => {
                            const stateToPass = { caseNoteData: note };
                            localStorage.setItem('caseNoteData', JSON.stringify(stateToPass));
                            handleSettingSkAndPkToLocalStorage(sk, pk);
                          }}
                        >
                          {note?.call_type === 'incoming'
                            ? note?.caller_name?.client_name || emptyDataValue
                            : note?.person_called?.client_name || emptyDataValue}
                        </Link>
                        <Link
                          to={
                            created_by_firm_user_id ? `/settings/team-management/${created_by_firm_user_id}` : '/settings/team-management'
                          }
                          onClick={() => {
                            // Save the state so it's available in the destination page
                            localStorage.setItem('caseNoteData', JSON.stringify({ caseNoteData: note }));

                            // Save sk/pk (if needed)
                            handleSettingSkAndPkToLocalStorage(sk, pk);
                          }}
                          className={`mx-2 ${classNames({
                            'redirection-link-no-text-transform': Boolean(generateFullName(note?.created_by_name)),
                          })}`}
                          style={{ cursor: 'pointer', textDecoration: 'none' }} // optional, to make it look/feel like a link
                        >
                          {note?.created_by_firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                          {note?.created_by_name ? generateFullName(note?.created_by_name) : 'N/A'}
                        </Link>
                      </div>
                    )}
                  </div>
                  <div className="col-sm-3">
                    <div className="text-muted">
                      {note && note.time
                        ? convertDateFromApiToUserTimezone(
                            note.time,
                            userDetails?.userDetails?.timezone,
                            constants.month_date_year_time_12_format
                          )
                        : emptyDataValue}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="d-flex align-items-center flex-wrap ">
                      <div className="col-sm-8 d-flex align-items-center">
                        <Checkbox
                          onChange={(e) => {
                            updateCaseNoteDetails(note, e.checked);
                            setResolved({
                              ...resolved,
                              [e.target.id]: e.checked,
                            });
                          }}
                          id={note.case_note_id}
                          checked={resolved[note.case_note_id]}
                        />
                        <label htmlFor={note.case_note_id} className="ps-2 p-checkbox-label">
                          Resolved
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}

        {leadDetails?.message_need_resolution
          // {caseSecureMessages
          ?.filter((dat) => dat?.resolution_status && !dat?.resolved_status)
          .map((msg, index) => {
            const { sk, pk, case_id } = msg;

            return (
              <Card className="mb-3 card-bg" key={`msg-${index}`}>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="d-flex align-items-center F-size14 text-medium p-lg-0 py-2 w-100">
                      <div className="icon-container icon-bg text-primary-dark mx-1">
                        <i className="icon-messages icon-bg text-primary-dark mx-1 flex-shrink-0"></i>
                      </div>
                      {msg?.subject ? (
                        <span
                          title={msg?.subject}
                          onClick={(e) => {
                            e.preventDefault();
                            const caseId = case_id || leadDetails?.case_id;
                            let url = caseId ? `/leads/${caseId}/messages/${msg?.message_thread_id}` : '/leads';
                            let stateToPass = { caseNoteData: msg };

                            handleRedirectionInLeadOverViewPage({ history, url, stateToPass, sk, pk });
                          }}
                          className={`note text-truncate w-100 call-back ${msg?.subject ? 'pointer' : ''}`}
                        >
                          {msg?.subject}
                        </span>
                      ) : (
                        emptyDataValue
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div
                      className={`mx-2 ${classNames({
                        'redirection-link-no-text-transform': Boolean(generateFullName(msg?.author_details)),
                      })}`}
                      onClick={() => {
                        let userId = null;
                        let url = null;

                        if (msg?.author_details?.firm_user_id) {
                          userId = msg?.author_details?.firm_user_id;
                          url = userId ? `/settings/team-management/${userId}` : '/settings/team-management';
                        } else if (msg?.author_details?.contact_id) {
                          userId = msg?.author_details?.contact_id;
                          url = userId ? `/contacts/${userId}` : '/contacts';
                        }

                        let stateToPass = { caseNoteData: msg };

                        handleRedirectionInLeadOverViewPage({ history, url, stateToPass, sk, pk });
                      }}
                    >
                      {msg?.author_details?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                      {msg?.author_details ? generateFullName(msg?.author_details) : emptyDataValue}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="text-muted">
                      {msg && msg.time
                        ? convertDateFromApiToUserTimezone(
                            msg.time,
                            userDetails?.userDetails?.timezone,
                            constants.month_date_year_time_12_format
                          )
                        : emptyDataValue}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="d-flex align-items-center flex-wrap ">
                      <div className="col-sm-8 d-flex align-items-center">
                        <Checkbox
                          onChange={(e) => {
                            updateSecureMessageDetails(msg, e.checked);
                            setResolved({
                              ...resolved,
                              [e.target.id]: e.checked,
                            });
                          }}
                          id={msg.message_thread_id}
                          checked={resolved[msg.message_thread_id]}
                        />
                        <label htmlFor={msg.message_thread_id} className="ps-2 p-checkbox-label">
                          Resolved
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
      </Card>
    </>
  );
}
